var render, staticRenderFns
import script from "./authredirect.vue?vue&type=script&lang=js&"
export * from "./authredirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d22ffdf8')) {
      api.createRecord('d22ffdf8', component.options)
    } else {
      api.reload('d22ffdf8', component.options)
    }
    
  }
}
component.options.__file = "src/views/login/authredirect.vue"
export default component.exports